import { Controller } from "@hotwired/stimulus"

// Handles client-side UI state for the pre-sale cart page.
export default class extends Controller {
  static targets = ["animateIn", "fadeOut"]

  connect() {
    // Animate sections in after Turbo Frame render
    requestAnimationFrame(() => {
      this.animateInTargets.forEach((el, index) => {
        const cls = el.dataset.animateClass
        if (cls) {
          setTimeout(() => el.classList.add(cls), index * 80)
        }
      })

      // Fade out sections when last item removed
      this.fadeOutTargets.forEach((el, index) => {
        const cls = el.dataset.fadeClass
        if (cls) {
          setTimeout(() => el.classList.remove(cls), index * 60)
        }
      })
    })
  }

  submitCountryForm(event) {
    event.target.form.requestSubmit()
  }
}
